<template>
  <VContainer fluid class="pa-0">
    <VRow no-gutters class="img-grid">
      <VCol
        v-for="(product, i) in visibleProducts"
        :key="product.id"
        :cols="cols"
        class="pa-0"
      >
        <ProductCard
          :product="product"
          :source="source"
          :hide-wishlist="hideWishlist"
          :sizes="sizes"
          show-add-button
          :truncate-title="2"
          class="pb-6"
          data-testid="product-card"
          @clicked-product="productClicked(product, i)"
        />
      </VCol>
    </VRow>

    <!-- Show More Button -->
    <VRow v-if="hasMoreProducts" no-gutters class="justify-center pb-3">
      <VCol cols="auto">
        <SBtn
          text
          class="text-underline text-capitalize font-weight-medium"
          data-testid="load-more"
          @click="loadMore"
        >
          {{ $t('input.btn.showMore') }}
        </SBtn>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script lang="ts" setup>
import ProductCard from '~/components/categories/ProductCard.vue'
import { CARD_SIZES } from '~/utils/format/imageSizes'
import type { ProductAPIResponse, ProductAPIResponse as Product } from '~/types/shop'
import { pushSelectItem } from '~/utils/gtm'
import type { AddToCartSource } from '~/stores/cart'

interface Props {
  background?: string
  products?: Product[]
  hideWishlist?: boolean
  cols?: '2' | '3' | '4' | '6'
  /** The CSS slot a tile fills; a caller rendering into a fixed panel states px. */
  sizes?: string
  source?: AddToCartSource
}

const props = withDefaults(defineProps<Props>(), {
  background: 'white',
  products: () => [],
  hideWishlist: false,
  cols: undefined,
  sizes: CARD_SIZES,
  source: undefined
})

const { proxy: gtm } = useScriptGoogleTagManager()

const itemsPerLoad = 6
const visibleCount = ref(itemsPerLoad)

const visibleProducts = computed(() => (props.products || []).slice(0, visibleCount.value))
const hasMoreProducts = computed(() => visibleCount.value < (props.products || []).length)

const productClicked = (product: ProductAPIResponse, position: number) => {
  pushSelectItem(gtm, product, position)
}

const loadMore = () => {
  // Increase visible count by itemsPerLoad
  const newCount = Math.min(visibleCount.value + itemsPerLoad, props.products.length)
  visibleCount.value = newCount
}
</script>

  <style lang='scss' scoped>
  </style>
